import * as builders from './builders';

export const translateContentToProps = content => {
  let questionType;
  if (
    content.component === 'flagship_ab_test' ||
    content.question?.[0].component === 'flagship_ab_test'
  ) {
    questionType = content.question?.[0].variants[0]?.blocks[0]?.component;
  } else {
    questionType = content.question?.[0].component ?? content.component;
  }
  // eslint-disable-next-line import/namespace
  const builder = /** @type {Record<string, any>} */ (builders)[questionType];
  // A missing builder means the CMS content references a component type this
  // build doesn't know about — usually stale content (an env whose Storyblok
  // cache predates a content migration) or content published ahead of a deploy.
  // Degrade gracefully instead of throwing through React render and 500ing.
  if (!builder) {
    // eslint-disable-next-line no-console
    console.warn(
      `[onboarding] No CMS builder for questionType "${questionType}" (component "${content.component}"). Content is likely stale or ahead of this build.`,
    );
    return {};
  }
  return builder.validateSync(content);
};
